// extracted by mini-css-extract-plugin
export default {"Content":"ButtonTextSimple_Content__CyJ66"};